import { QuestionTopChoices } from '../../../../entities/candidate_experience/QuestionTopChoices';
import { Col, Row } from 'reactstrap';
import {
  TopChoices,
  TopChoicesChartType,
} from '../../shared_panels/TopChoices';
import stylesheetExports from '../../../../stylesheets/export.module.scss';
import React from 'react';
import classNames from 'classnames';
import { REPORTING_SECTION_CLASS } from '../../../../utils/pdfHandler';
import { PageBreak } from '../PageBreak';

export function ApplicationImprovementTopChoices(props: {
  applicationImprovements: QuestionTopChoices;
}) {
  if (props.applicationImprovements == null) return null;
  if (props.applicationImprovements.top_choices.length === 0) return null;

  return (
    <>
      <PageBreak />
      <Row className={classNames(REPORTING_SECTION_CLASS)}>
        <Col xs='12'>
          <TopChoices
            title='Application Improvements'
            subtitle={props.applicationImprovements.question_text}
            topChoices={props.applicationImprovements.top_choices}
            fillColor={stylesheetExports.chartOrange}
            type={TopChoicesChartType.Bar}
          />
        </Col>
      </Row>
    </>
  );
}
